export default {
      id: "ic_rank_badge_second-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_rank_badge_second-usage",
      toString: function () {
        return this.url;
      }
    }